import t from '../actions/actionTypes'
import confirmTypes from 'helpers/enums/confirmTypes'
import errorCodes from 'helpers/enums/errorCodes'
import sessionTypes from 'helpers/enums/sessionTypes'
import lessonSources from 'helpers/enums/lessonSources'
import localErrorCodes from 'helpers/enums/errors/localErrorCodes'

const defaultState = []

function removeConfirm(state, type) {
	const index = state.findIndex(confirm => confirm.confirmType === type)
	if (index !== -1) {
		return state.filter((item, i) => i !== index)
	} else {
		return state
	}
}

function displayGeneralConfirmMessage(state, action) {
	return [...state,
		{
			confirmType: confirmTypes.GENERAL_CONFIRM,
			confirmProps: {message: action.payload.message},
		}]
}

function studentSubmitConfirmed(state, action) {
	const isHomework = action.sessionType === sessionTypes.HOMEWORK
	if (action.isAutoSubmit) {
		return state
	} else if (isHomework) {
		return [...defaultState]
	} else {
		return [...defaultState, {
			confirmType: action.type,
		}]
	}
}

function studentDrawItSubmitConfirmed(state, action) {
	const isHomework = action.sessionType === sessionTypes.HOMEWORK
	if (action.isAutoSubmit) {
		return state
	} else if (isHomework) {
		if (!action.slide_data.answers.length && action.slide_data.isSubmissionRequired && action.shouldEnforceSubmission) {
			return [...defaultState, {
				confirmType: confirmTypes.STUDENT_SUBMIT_DRAWIT_REQUIRED,
			}]
		}
		return [...defaultState]
	} else {
		return [...defaultState, {
			confirmType: action.type,
		}]
	}
}

function confirmSubmitFailed(state, action) {
	const isHomework = action.sessionType === sessionTypes.HOMEWORK
	if (action.error.error_code === localErrorCodes.DRAWIT_SUBMISSION_REQUIRED) {
		return [...defaultState, {
			confirmType: confirmTypes.STUDENT_SUBMIT_DRAWIT_REQUIRED,
		}]
	} else if (isHomework) {
		return [...defaultState]
	}
	return [...defaultState, {
		confirmType: confirmTypes.STUDENT_SUBMIT_FAILED_CONFIRM,
	}]
}

function studentQuizSubmitQuiz(state, action) {
	const isPreview = action.sessionType === sessionTypes.PREVIEW
	const isEmbed = action.sessionType === sessionTypes.EMBED
	const isTSV = action.sessionType === sessionTypes.TEACHER_STUDENT_VIEW

	if (!(isPreview || isEmbed || isTSV)) {
		const emptyQuestions = action.slide_data.questions.find(question => question.selected_answers.length === 0)
		const isHomework = action.sessionType === sessionTypes.HOMEWORK
		const showSubmissionNotification = !isHomework
		if (emptyQuestions) {
			if (!action.slide_data.isSubmissionRequired) {
				return [...defaultState, {
					confirmType: t.STUDENT_SUBMIT_QUIZ_EMPTY_ANSWERS_CONFIRM,
				}]
			} else if (action.shouldEnforceSubmission) {
				return [...defaultState, {
					confirmType: confirmTypes.STUDENT_SUBMIT_QUIZ_EMPTY_ANSWERS_REQUIRED,
				}]
			}
		}

		if (showSubmissionNotification) {
			return [...defaultState, {
				confirmType: t.STUDENT_SUBMIT_QUIZ_CONFIRMED,
			}]
		}
	}

	return state
}

function studentSubmitOeqAnswer(state, action) {
	const isPreview = action.sessionType === sessionTypes.PREVIEW
	const isEmbed = action.sessionType === sessionTypes.EMBED
	const isTSV = action.sessionType === sessionTypes.TEACHER_STUDENT_VIEW

	if (!(isPreview || isEmbed || isTSV)) {
		const isHomework = action.sessionType === sessionTypes.HOMEWORK
		const answer = action.slide_data.answers[0].text
		const emptyAnswer = !(answer && answer !== '') && !action.slide_data.audioClientUid
		if (emptyAnswer
			&& (action.shouldEnforceSubmission || !action.slide_data.isSubmissionRequired)
		) {
			if (action.slide_data.isSubmissionRequired) {
				return [...defaultState, {
					confirmType: confirmTypes.STUDENT_SUBMIT_OEQ_EMPTY_ANSWER_REQUIRED,
				}]
			} else {
				return [...defaultState, {
					confirmType: t.STUDENT_SUBMIT_OEQ_EMPTY_ANSWER_CONFIRM,
				}]
			}
		} else if (!isHomework) {
			return [...defaultState, {
				confirmType: t.STUDENT_SUBMIT_OEQ_CONFIRMED,
			}]
		}
	}
	return state
}


function studentPollSubmitPoll(state, action) {
	const isPreview = action.sessionType === sessionTypes.PREVIEW
	const isEmbed = action.sessionType === sessionTypes.EMBED
	const isTSV = action.sessionType === sessionTypes.TEACHER_STUDENT_VIEW
	if (!(isPreview || isEmbed || isTSV)) {
		const emptyPoll = action.slide_data.answers.length === 0
		const isHomework = action.sessionType === sessionTypes.HOMEWORK
		if (emptyPoll
			&& (action.shouldEnforceSubmission || !action.slide_data.isSubmissionRequired)
		) {
			if (action.slide_data.isSubmissionRequired) {
				return [...defaultState, {
					confirmType: confirmTypes.STUDENT_SUBMIT_POLL_EMPTY_ANSWERS_REQUIRED,
				}]
			} else {
				return [...defaultState, {
					confirmType: t.STUDENT_SUBMIT_POLL_EMPTY_ANSWERS_CONFIRM,
				}]
			}
		} else if (!isHomework) {
			return [...defaultState, {
				confirmType: t.STUDENT_SUBMIT_POLL_CONFIRMED,
			}]
		}
	}
	return state
}

function premiumFeatureUpgrade(action, isIframeView) {
	return [...defaultState, {
		confirmType: confirmTypes.MY_LIBRARY_PREMIUM_FEATURE_UPGRADE,
		confirmProps: {sessionData: action.payload, isIframeView},
	}]
}

function duplicateLessonConfirm(state, action) {
	if (action.lessonData.sourceInfo.type === lessonSources.GOOGLE_SLIDES) {
		return [...defaultState, {
			confirmType: confirmTypes.MY_LIBRARY_DUPLICATE_CONFIRM,
			confirmProps: {lessonData: action.lessonData},
		}]
	} else {
		return state
	}
}

function storeEntityAddedToPrivateLibrary(state, action) {
	return [...defaultState, {
		confirmType: confirmTypes.PRIVATE_LIBRARY_ADD_TO_PRIVATE_LIBRARY_REDIRECT,
		confirmProps: {libraryType: action.libraryType, libraryId: action.libraryId, entityType: action.entityType},
	}]
}

function googleSlidesLessonSavedFailed(state, action) {
	let confirmType = confirmTypes.GOOGLE_SLIDES_SAVE_PRESENTATION_FAILED_CONFIRM

	if (action.error.error_code === errorCodes.GOOGLE_SLIDES_SAVE_MEDIA_FAILED) {
		confirmType = confirmTypes.GOOGLE_SLIDES_SAVE_MEDIA_FAILED_CONFIRM
	}

	return [...defaultState, {
		confirmType,
		confirmProps: { error: action.error },
	}]
}

function googleSlidesAuthorizeUserFailed(state, action) {
	if (action.error.error_code === errorCodes.GOOGLE_SLIDES_POP_UP_BLOCKED) {
		return [...defaultState, {
			confirmType: confirmTypes.GOOGLE_SLIDES_POP_UP_BLOCKED_CONFIRM,
			confirmProps: { error: action.error },
		}]
	} else if (action.error.message && action.error.message.includes('Cookies')) {
		const confirmType = confirmTypes.COOKIES_DISABLED_ERROR

		return [...defaultState, {
			confirmType,
		}]
	} else {
		return state
	}
}

function googleSlidesCreateLessonSuccess(state, action) {
	if (action.isInIframe) {
		return [...defaultState, {
			confirmType: confirmTypes.GOOGLE_SLIDES_LMS_OPEN_GOOGLE_CONFIRM,
			confirmProps: { redirectUrl: action.lessonData.webViewLink },
		}]
	}

	return state
}

function googleSlidesLMSOpenGoogleConfirmed(state) {
	const newState = removeConfirm(state, confirmTypes.GOOGLE_SLIDES_LMS_OPEN_GOOGLE_CONFIRM)
	return [...newState, {
		confirmType: confirmTypes.GOOGLE_SLIDES_LMS_REFRESH_CONFIRM,
	}]
}

function studentRequestMicPermission() {
	return [...defaultState, {
		confirmType: confirmTypes.STUDENT_REQUEST_MIC_PERMISSION,
	}]
}

function quickLaunchLessonFailed() {
	return [...defaultState, {
		confirmType: confirmTypes.QUICK_LAUNCH_LAUNCH_LESSON_FAILED,
	}]
}

function studentLeadShowMessage(action) {
	if (action.sessionType !== sessionTypes.HOMEWORK && action.data.payload) {
		const confirm = {confirmType: confirmTypes.STUDENT_LEAD_MESSAGE}

		if (action.data.payload.show_welcome === '1') {
			return [...defaultState, confirm]
		} else if (action.data.payload.title && action.data.message) {
			return [...defaultState, {...confirm, confirmProps: {
				title: action.data.payload.title,
				message: action.data.message,
			}}]
		}
	}

	return defaultState
}

function openCartFailedPaywall(state, action) {
	if (action.serverError.error_code === errorCodes.NOT_ENOUGH_SPACE_IN_MY_LIBRARY) {
		return [...defaultState, {
			confirmType: confirmTypes.PAYWALLS_NOT_ENOUGH_SPACE_CONFIRM,
			confirmProps: {
				offerMessage: action.serverError.payload.maxStorage.offerMessage,
				buttons: action.serverError.payload.maxStorage.buttons,
			},
		}]
	}
	return state
}

function openCheckStoragePaywall(state, action) {
	const noStorageConfirmTypes = {
		[`${errorCodes.EXCEED_MAX_USER_STORAGE}`]: confirmTypes.PAYWALLS_NOT_ENOUGH_SPACE_CONFIRM,
		[`${errorCodes.EXCEED_MAX_PRESENTATION_SIZE}`]: confirmTypes.PAYWALL_PRESENTATION_SIZE_CONFIRM,
	}
	const confirmType = noStorageConfirmTypes[action.serverError.error_code]
	if (confirmType) {
		return [...state, {
			confirmType,
			confirmProps: {
				upgradeSource: action.upgradeSource,
			},
		}]
	}
	return state
}

function drawItDeleteAudioRecorderConfirm(state, action) {
	if (action.hasAudioRecorded) {
		return [...state, {
			confirmType: confirmTypes.DRAW_IT_AUDIO_RECORDER_DELETE_CONFIRM,
		}]
	}
	return state
}

const confirmReducer = (state = defaultState, action) => {
	switch (action.type) {
		case t.OPEN_CONFIRM:
			return [...defaultState, action]
		case t.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_CONFIRMATION:
			return [...defaultState, {confirmType: confirmTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_CONFIRM}]
		case t.ADMIN_ONBOARDING_INVITE_CONFIRMATION:
			return [...defaultState, {confirmType: confirmTypes.ADMIN_ONBOARDING_INVITE_CONFIRM}]
		case t.PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_CONFIRM:
			return [...defaultState, {confirmType: confirmTypes.PRIVATE_LIBRARY_PAID_LESSONS_ADD}]
		case t.PRIVATE_LIBRARY_OPEN_DELETE_CURRENT_FOLDER_CONFIRM:
			return [...defaultState, {confirmType: confirmTypes.PRIVATE_LIBRARY_DELETE_CURRENT_FOLDER}]
		case t.PRIVATE_LIBRARY_DELETE_LESSON_CONFIRM:
			return [...defaultState, {
				confirmType: confirmTypes.PRIVATE_LIBRARY_REMOVE_LESSON,
				confirmProps: {entityType: action.entityType},
			}]
		case t.CART_ITEM_ADDED:
			return [...defaultState, {
				confirmType: confirmTypes.CART_ITEM_ADDED,
				confirmProps: {entityUID: action.entityUID, entityType: action.entityType},
			}]
		case t.CART_ITEM_FAILED:
			return openCartFailedPaywall(state, action)
		case t.INTERACTIVE_VIDEO_UPLOAD_VIDEO_FAILED:
		case t.VIDEO_STORE_LESSON_COPIED_FAILED:
		case t.ACTIVITY_BANKS_ACTIVITY_UPDATE_FAILED:
			return openCheckStoragePaywall(state, action)
		case t.CLOSE_CONFIRM: {
			return removeConfirm(state, action.confirmType)
		}
		case t.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_CONFIRMED:
		case t.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_CANCELED:
			return removeConfirm(state, confirmTypes.ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_CONFIRM)
		case t.ADMIN_ONBOARDING_INVITE_CONFIRMED:
		case t.ADMIN_ONBOARDING_INVITE_CANCELED:
			return removeConfirm(state, confirmTypes.ADMIN_ONBOARDING_INVITE_CONFIRM)
		case t.POLL_CANCEL_POLL_CONFIRM:
			return [...defaultState, {
				confirmType: confirmTypes.POLL_CANCEL_CONFIRM,
			}]
		case t.POLL_CANCEL_POLL_CONFIRMED:
		case t.POLL_CANCEL_POLL_REJECTED:
			return removeConfirm(state, confirmTypes.POLL_CANCEL_CONFIRM)
		case t.OEQ_AUDIO_PLAYER_DELETE_CONFIRM:
			return [...defaultState, {
				confirmType: confirmTypes.OEQ_AUDIO_PLAYER_DELETE_CONFIRM,
			}]
		case t.OEQ_AUDIO_PLAYER_DELETE_CONFIRMED:
		case t.OEQ_AUDIO_PLAYER_DELETE_CANCELLED:
			return removeConfirm(state, confirmTypes.OEQ_AUDIO_PLAYER_DELETE_CONFIRM)
		case t.OEQ_CANCEL_OEQ_CONFIRM:
			return [...defaultState, {
				confirmType: confirmTypes.OEQ_CANCEL_CONFIRM,
			}]
		case t.OEQ_CANCEL_OEQ_CONFIRMED:
		case t.OEQ_CANCEL_OEQ_REJECTED:
			return removeConfirm(state, confirmTypes.OEQ_CANCEL_CONFIRM)
		case t.POLL_INITIALIZE_ERROR:
		case t.OEQ_INITIALIZE_ERROR:
			return [...defaultState, { confirmType: confirmTypes.POLL_INITIALIZE_ERROR }]
		case t.OEQ_UPLOAD_REFERENCE_MEDIA_ERROR:
		case t.OEQ_UPLOADER_VALIDATE_ERROR:
		case t.OEQ_UPLOADER_UPLOAD_ERROR:
		case t.POLL_UPLOAD_REFERENCE_MEDIA_ERROR:
		case t.POLL_UPLOADER_VALIDATE_ERROR:
		case t.POLL_UPLOADER_UPLOAD_ERROR:
			return [...defaultState, {
				confirmType: confirmTypes.POLL_UPLOAD_REFERENCE_MEDIA_ERROR,
				confirmProps: {message: action.message},
			}]
		case t.POLL_UPLOADER_VALIDATE_CONTENT_ERROR:
			return [...defaultState, {
				confirmType: confirmTypes.POLL_UPLOAD_REFERENCE_MEDIA_CONTENT_ERROR,
				confirmProps: {message: action.message, questionId: action.questionId},
			}]
		case t.OEQ_UPLOADER_VALIDATE_CONTENT_ERROR:
			return [...defaultState, {
				confirmType: confirmTypes.OEQ_UPLOAD_REFERENCE_MEDIA_CONTENT_ERROR,
				confirmProps: {message: action.message, questionId: action.questionId},
			}]
		case t.PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_CANCELLED:
		case t.PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_CONFIRMED:
			return removeConfirm(state, confirmTypes.PRIVATE_LIBRARY_PAID_LESSONS_ADD)
		case t.PRIVATE_LIBRARY_DELETE_CURRENT_FOLDER_CANCEL:
		case t.PRIVATE_LIBRARY_DELETE_CURRENT_FOLDER_SUCCESS:
			return removeConfirm(state, confirmTypes.PRIVATE_LIBRARY_DELETE_CURRENT_FOLDER)
		case t.PRIVATE_LIBRARY_DELETE_LESSON_CANCELLED:
		case t.PRIVATE_LIBRARY_DELETE_LESSON_SUCCESS:
		case t.PRIVATE_LIBRARY_DELETE_LESSON_ERROR:
			return removeConfirm(state, confirmTypes.PRIVATE_LIBRARY_REMOVE_LESSON)
		case t.SIGNUP_STUDENT_CONFIRMED:
		case t.SIGNUP_TEACHER_CONFIRMED:
			return removeConfirm(state, confirmTypes.SIGNUP_STUDENT_VALIDATION)
		case t.QUIZ_UPLOAD_REFERENCE_MEDIA_ERROR:
		case t.QUIZ_UPLOADER_VALIDATE_ERROR:
		case t.QUIZ_UPLOADER_UPLOAD_ERROR:
		case t.PROCESSING_ICON_ERROR:
			//@todo: hmike: convert it into generic confirm
			return [...defaultState, {
				confirmType: confirmTypes.QUIZ_UPLOAD_REFERENCE_MEDIA_ERROR,
				confirmProps: {message: action.message},
			}]
		case t.QUIZ_UPLOADER_VALIDATE_CONTENT_ERROR:
			return [...defaultState, {
				confirmType: confirmTypes.QUIZ_UPLOAD_REFERENCE_MEDIA_CONTENT_ERROR,
				confirmProps: {message: action.message, questionId: action.questionId},
			}]
		case t.QUIZ_CANCEL_QUIZ_CONFIRM:
			return [...defaultState, {
				confirmType: confirmTypes.QUIZ_CANCEL_CONFIRM,
			}]
		case t.QUIZ_CANCEL_QUIZ_CONFIRMED:
		case t.QUIZ_CANCEL_QUIZ_REJECTED:
			return removeConfirm(state, confirmTypes.QUIZ_CANCEL_CONFIRM)
		case t.QUIZ_INITIALIZE_ERROR:
			return [...defaultState, { confirmType: confirmTypes.QUIZ_INITIALIZE_ERROR }]
		case t.MATCHING_PAIRS_CT_PAIR_IMAGE_PICK_VALIDATE_ERROR:
			if (action.error_code === errorCodes.EXCEED_MAX_PRESENTATION_SIZE
					|| action.error_code === errorCodes.EXCEED_MAX_USER_STORAGE) {
				return [...defaultState, {
					confirmType: confirmTypes.MATCHING_PAIRS_UPLOAD_MEDIA_ERROR,
					confirmProps: {message: action.message},
				}]
			} else {
				return state
			}
		case t.STOREFRONT_REMOVE_LESSON_CONFIRM:
			return [...defaultState, { confirmType: confirmTypes.STOREFRONT_REMOVE_LESSON, confirmProps: {entityUID: action.entityUID} }]
		case t.STOREFRONT_REMOVE_LESSON_CANCELLED:
		case t.STOREFRONT_REMOVE_LESSON_SUCCESS:
		case t.STOREFRONT_REMOVE_LESSON_CONFIRMED:
			return removeConfirm(state, confirmTypes.STOREFRONT_REMOVE_LESSON)
		case t.QUIZ_QUESTION_SAVE_ERROR:
			if (action.error.error_code === errorCodes.EXCEED_MAX_PRESENTATION_SIZE
					|| action.error.error_code === errorCodes.EXCEED_MAX_USER_STORAGE) {
				return [...defaultState, {
					confirmType: confirmTypes.QUIZ_UPLOAD_REFERENCE_MEDIA_ERROR,
					confirmProps: {message: action.message},
				}]
			} else {
				return state
			}
		case t.MATCHING_PAIRS_CT_DELETE_PAIR:
			return [...defaultState, { confirmType: confirmTypes.MATCHING_PAIRS_PAIR_DELETE_CONFIRM,
				confirmProps: {pairId: action.id} }]
		case t.MATCHING_PAIRS_CT_PAIR_DELETE_CONFIRMED:
		case t.MATCHING_PAIRS_CT_PAIR_DELETE_REJECTED:
			return removeConfirm(state, confirmTypes.MATCHING_PAIRS_PAIR_DELETE_CONFIRM)
		case t.MATCHING_PAIRS_CT_CANCEL_MP_CONFIRM:
			return [...defaultState, {
				confirmType: confirmTypes.MATCHING_PAIRS_CANCEL_CONFIRM,
			}]
		case t.MATCHING_PAIRS_CT_CANCEL_MP_CONFIRMED:
		case t.MATCHING_PAIRS_CT_CANCEL_MP_REJECTED:
			return removeConfirm(state, confirmTypes.MATCHING_PAIRS_CANCEL_CONFIRM)
		case t.USER_NOT_LOGGED_IN_CONFIRM:
			return [...defaultState, {
				confirmType: confirmTypes.USER_NOT_LOGGED_IN_CONFIRM,
			}]
		case t.DRAW_IT_UPLOAD_REFERENCE_MEDIA_ERROR:
		case t.DRAW_IT_UPLOADER_VALIDATE_ERROR:
		case t.DRAW_IT_UPLOADER_UPLOAD_ERROR:
		case t.DRAW_IT_VALIDATE_BACKGROUND_IMAGE_ERROR:
		case t.DRAW_IT_UPLOAD_BACKGROUND_IMAGE_ERROR:
			return [...defaultState, {
				confirmType: confirmTypes.DRAW_IT_UPLOAD_REFERENCE_MEDIA_ERROR,
				confirmProps: {message: action.message},
			}]
		case t.DRAW_IT_UPLOADER_VALIDATE_CONTENT_ERROR:
			return [...defaultState, {
				confirmType: confirmTypes.DRAW_IT_UPLOAD_REFERENCE_MEDIA_CONTENT_ERROR,
				confirmProps: {message: action.message},
			}]
		case t.DRAW_IT_CANCEL_DRAW_IT_CONFIRM:
			return [...defaultState, {
				confirmType: confirmTypes.DRAW_IT_CANCEL_CONFIRM,
			}]
		case t.DRAW_IT_CANCEL_DRAW_IT_CONFIRMED:
		case t.DRAW_IT_CANCEL_DRAW_IT_REJECTED:
			return removeConfirm(state, confirmTypes.DRAW_IT_CANCEL_CONFIRM)
		case t.DRAW_IT_INITIALIZE_ERROR:
			return [...defaultState, { confirmType: confirmTypes.DRAW_IT_INITIALIZE_ERROR }]
		case t.PRIVATE_LIBRARY_ADD_TO_PRIVATE_LIBRARY_REDIRECT:
			return [...defaultState, {
				confirmType: confirmTypes.PRIVATE_LIBRARY_ADD_TO_PRIVATE_LIBRARY_REDIRECT,
				confirmProps: {libraryType: action.libraryType, libraryId: action.libraryId, entityType: action.entityType},
			}]
		case t.PRIVATE_LIBRARY_MANAGE_LIBRARY_REDIRECT:
		case t.PRIVATE_LIBRARY_VIEW_LIBRARY_REDIRECT:
			return removeConfirm(state, confirmTypes.PRIVATE_LIBRARY_ADD_TO_PRIVATE_LIBRARY_REDIRECT)
		case t.PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_MUTIPLE_SCHOOLS_CONFIRM:
			return [...defaultState, {
				confirmType: confirmTypes.PRIVATE_LIBRARY_ADD_TO_MULTIPLE_SCHOOLS,
				confirmProps: {alertTitle: action.alertTitle},
			}]
		case t.PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_MULTIPLE_SCHOOLS_CONFIRMED:
		case t.PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_MULTIPLE_SCHOOLS_DENIED:
		case t.PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_MULTIPLE_SCHOOLS_CANCELLED:
			return removeConfirm(state, confirmTypes.PRIVATE_LIBRARY_ADD_TO_MULTIPLE_SCHOOLS)
		case t.PRIVATE_LIBRARY_DELETE_LESSON_MULTIPLE_SCHOOLS_CONFIRM:
			return [...defaultState, {
				confirmType: confirmTypes.PRIVATE_LIBRARY_REMOVE_LESSON_MULTIPLE_SCHOOLS,
				confirmProps: {entityType: action.entityType},
			}]
		case t.PRIVATE_LIBRARY_DELETE_LESSON_MULTIPLE_SCHOOLS_CONFIRMED:
		case t.PRIVATE_LIBRARY_DELETE_LESSON_CONFIRMED:
		case t.PRIVATE_LIBRARY_DELETE_LESSON_MULTIPLE_SCHOOLS_CANCELLED:
			return removeConfirm(state, confirmTypes.PRIVATE_LIBRARY_REMOVE_LESSON_MULTIPLE_SCHOOLS)
		case t.MY_LIBRARY_SESSION_FETCHED:
			if (action.payload.hasPreviousSession === true && action.payload.multiplePins === false) {
				return [...defaultState, {
					confirmType: confirmTypes.MY_LIBRARY_HAS_SINGLE_SESSION,
					confirmProps: {presentation_uid: action.presentation_uid, session_uid: action.payload.session_uid},
				}]
			} else {
				return state
			}
		case t.MY_LIBRARY_HOMEWORK_FETCHED:
			if (action.payload.hwTrial && action.payload.hwTrial.showMessage === '1') {
				return premiumFeatureUpgrade(action, false)
			} else {
				return state
			}
		case t.MY_LIBRARY_EXTENSION_PREMIUM_FEATURE_UPGRADE:
			return premiumFeatureUpgrade(action, true)
		case t.MY_LIBRARY_CANCEL_SESSION_LAUNCH:
		case t.MY_LIBRARY_LAUNCH_NEW_LIVE_SESSION:
		case t.MY_LIBRARY_RESUME_ACTIVE_LIVE_SESSION:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_HAS_SINGLE_SESSION)
		case t.MY_LIBRARY_SAVE_CHANGES_FETCHED:
			if (action.saveResponse.error_code === 1) {
				return [...defaultState, {
					confirmType: confirmTypes.MY_LIBRARY_SAVE_CHANGES_CONFIRM,
					confirmProps: {
						message: action.saveResponse.message,
					},
				}]
			} else {
				return state
			}
		case t.MY_LIBRARY_CLOSE_SAVE_CONFIRM:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_SAVE_CHANGES_CONFIRM)
		case t.MY_LIBRARY_DUPLICATE_LESSON_FAILED:
		case t.MY_LIBRARY_EDIT_LESSON_FAILED:
			if (action.payload && action.payload.error_code === 1) {
				return displayGeneralConfirmMessage(state, action)
			} else {
				return state
			}
		case t.MY_LIBRARY_DELETE_LESSON:
			return [...defaultState, {
				confirmType: confirmTypes.MY_LIBRARY_DELETE_LESSON,
				confirmProps: {lesson: action.lesson},
			}]
		case t.MY_LIBRARY_DELETE_LESSON_CANCELLED:
		case t.MY_LIBRARY_DELETE_LESSON_CONFIRMED:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_DELETE_LESSON)
		case t.MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER:
			return [...defaultState, {
				confirmType: confirmTypes.MY_LIBRARY_REMOVE_FROM_FOLDER_CONFIRM,
				confirmProps: {lesson: action.lesson, folder: action.folder},
			}]
		case t.MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER_CONFIRMED:
		case t.MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER_CANCELLED:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_REMOVE_FROM_FOLDER_CONFIRM)
		case t.MY_LIBRARY_EXPORT_TO_PDF:
			return [...defaultState, {
				confirmType: confirmTypes.MY_LIBRARY_EXPORT_TO_PDF_CONFIRM,
				confirmProps: {lesson: action.lesson},
			}]
		case t.MY_LIBRARY_CLOSE_EXPORT_TO_PDF_CONFIRM:
		case t.MY_LIBRARY_EXPORT_TO_LOCAL_DRIVE:
		case t.MY_LIBRARY_EXPORT_TO_GOOGLE_DRIVE:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_EXPORT_TO_PDF_CONFIRM)
		case t.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY:
			if (action.lesson.data.state === 0) {
				return [...defaultState, {
					confirmType: confirmTypes.MY_LIBRARY_SAVE_LESSON_NOTIFY,
					confirmProps: {library_type: action.library_type},
				}]
			} else {
				return state
			}
		case t.STORE_ADD_LESSON_TO_PRIVATE_LIBRARY_SUCCESS:
			return storeEntityAddedToPrivateLibrary(state, action)
		case t.MY_LIBRARY_SAVE_LESSON_NOTIFICATION_CLOSE:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_SAVE_LESSON_NOTIFY)
		case t.MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_SUCCESS:
			return [...defaultState, {
				confirmType: confirmTypes.MY_LIBRARY_LESSON_ADDED_TO_PRIVATE_LIBRARY,
				confirmProps: {library_uid: action.library_uid, library_type: action.library_type},
			}]
		case t.MY_LIBRARY_ADDED_LESSON_TO_PRIVATE_LIBRARY_CLOSE:
		case t.MY_LIBRARY_VISIT_PRIVATE_LIBRARY:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_LESSON_ADDED_TO_PRIVATE_LIBRARY)
		case t.MY_LIBRARY_REMOVE_FOLDER:
			return [...defaultState, {
				confirmType: confirmTypes.MY_LIBRARY_REMOVE_FOLDER_CONFIRM,
				confirmProps: {folder: action.folder},
			}]
		case t.MY_LIBRARY_CLOSE_REMOVE_FOLDER_CONFIRM:
		case t.MY_LIBRARY_DELETE_FOLDER_RESPONSE_SUCCESS:
		case t.MY_LIBRARY_DELETE_FOLDER_RESPONSE_FAILED:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_REMOVE_FOLDER_CONFIRM)
		case t.USER_UPGRADE_MESSAGE:
			return [...defaultState, {
				confirmType: confirmTypes.GENERAL_UPGRADE_CONFIRM,
				confirmProps: {upgrade_data: action.upgrade_data},
			}]
		case t.USER_UPGRADE_ACTION_SELECTED:
			return removeConfirm(state, confirmTypes.GENERAL_UPGRADE_CONFIRM)
		case t.MY_LIBRARY_EDIT_LESSON:
		case t.STORE_EDIT_LESSON:
			let newState = defaultState
			if (action.lessonData.inPublicLibrary) {
				newState = [...newState, {
					confirmType: confirmTypes.MY_LIBRARY_EDIT_LESSON_IN_PUBLIC_LIBRARY_CONFIRM,
					confirmProps: {lessonData: action.lessonData},
				}]
			}

			if (action.lessonData.isStore) {
				newState = [...newState, {
					confirmType: confirmTypes.MY_LIBRARY_EDIT_STORE_LESSON_CONFIRM,
					confirmProps: {lessonData: action.lessonData},
				}]
			}

			if (action.lessonData.is_running) {
				newState = [...newState, {
					confirmType: confirmTypes.MY_LIBRARY_EDIT_RUNNING_LESSON_CONFIRM,
					confirmProps: {lessonData: action.lessonData},
				}]
			}
			return newState
		case t.MY_LIBRARY_EDIT_LESSON_INIT:
		case t.MY_LIBRARY_EDIT_STORE_LESSON:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_EDIT_STORE_LESSON_CONFIRM)
		case t.MY_LIBRARY_EDIT_RUNNING_LESSON:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_EDIT_RUNNING_LESSON_CONFIRM)
		case t.MY_LIBRARY_DUPLICATE_LESSON_CONFIRMED:
		case t.MY_LIBRARY_CLOSE_EDIT_STORE_LESSON_CONFIRM:
		case t.MY_LIBRARY_CLOSE_EDIT_RUNNING_LESSON_CONFIRM:
		case t.MY_LIBRARY_CLOSE_EDIT_LESSON_IN_PUBLIC_LIBRARY_CONFIRM:
			const confirms = [
				confirmTypes.MY_LIBRARY_EDIT_STORE_LESSON_CONFIRM,
				confirmTypes.MY_LIBRARY_EDIT_RUNNING_LESSON_CONFIRM,
				confirmTypes.MY_LIBRARY_EDIT_LESSON_IN_PUBLIC_LIBRARY_CONFIRM,
				confirmTypes.MY_LIBRARY_DUPLICATE_CONFIRM,
			]
			return confirms.reduce((state, confirmType) => removeConfirm(state, confirmType), state)
		case t.MY_LIBRARY_EDIT_LESSON_IN_PUBLIC_LIBRARY:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_EDIT_LESSON_IN_PUBLIC_LIBRARY_CONFIRM)
		case t.MY_LIBRARY_HOMEWORK_UPGRADE_ACTION_SELECTED:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_PREMIUM_FEATURE_UPGRADE)
		case t.LOGIN_SSO_ERROR_CONFIRM_CONFIRMED:
			return removeConfirm(state, confirmTypes.LOGIN_SSO_ERROR)
		case t.STUDENT_SUBMIT_POLL_ANSWERS:
			return studentPollSubmitPoll(state, action)
		case t.STUDENT_SUBMIT_POLL_CONFIRMED:
			return studentSubmitConfirmed(state, action)
		case t.STUDENT_SUBMIT_POLL_CANCEL:
			return removeConfirm(state, confirmTypes.STUDENT_SUBMIT_POLL_EMPTY_ANSWERS_CONFIRM)
		case t.STUDENT_SUBMIT_POLL_REVIEW:
			return removeConfirm(state, confirmTypes.STUDENT_SUBMIT_POLL_EMPTY_ANSWERS_REQUIRED)
		case t.STUDENT_SUBMIT_POLL_EDIT:
			return removeConfirm(state, confirmTypes.STUDENT_SUBMIT_POLL_CONFIRMED)
		case t.STUDENT_SLIDE_CHECK_READY:
			if (action.slide_data.hasChanged) {
				return [...defaultState, {
					confirmType: confirmTypes.STUDENT_SLIDE_SUBMISSION_CONFIRM,
				}]
			} else {
				return state
			}
		case t.STUDENT_POLL_ENDED:
		case t.STUDENT_QUIZ_ENDED:
		case t.STUDENT_OEQ_ENDED:
		case t.STUDENT_DRAW_IT_ENDED:
		case t.STUDENT_LEAD_ENDED:
			return []
		case t.STUDENT_QUIZ_SUBMIT_QUIZ:
			return studentQuizSubmitQuiz(state, action)
		case t.STUDENT_SUBMIT_QUIZ_CONFIRMED:
			return studentSubmitConfirmed(state, action)
		case t.STUDENT_SUBMIT_QUIZ_CANCEL:
			return removeConfirm(state, confirmTypes.STUDENT_SUBMIT_QUIZ_EMPTY_ANSWERS_CONFIRM)
		case t.STUDENT_SUBMIT_QUIZ_REVIEW:
			return removeConfirm(state, confirmTypes.STUDENT_SUBMIT_QUIZ_EMPTY_ANSWERS_REQUIRED)
		case t.STUDENT_SUBMIT_QUIZ_EDIT:
			return removeConfirm(state, confirmTypes.STUDENT_SUBMIT_QUIZ_CONFIRMED)
		case t.STUDENT_SUBMIT_OEQ_ANSWER:
			return studentSubmitOeqAnswer(state, action)
		case t.STUDENT_SUBMIT_OEQ_CONFIRMED:
			return studentSubmitConfirmed(state, action)
		case t.STUDENT_SUBMIT_DRAWIT_CONFIRMED:
			return studentDrawItSubmitConfirmed(state, action)
		case t.STUDENT_SUBMIT_OEQ_CANCEL:
			return removeConfirm(state, confirmTypes.STUDENT_SUBMIT_OEQ_EMPTY_ANSWER_CONFIRM)
		case t.STUDENT_SUBMIT_OEQ_REVIEW:
			return removeConfirm(state, confirmTypes.STUDENT_SUBMIT_OEQ_EMPTY_ANSWER_REQUIRED)
		case t.STUDENT_SUBMIT_OEQ_EDIT:
			return removeConfirm(state, confirmTypes.STUDENT_SUBMIT_OEQ_CONFIRMED)
		case t.STUDENT_SUBMIT_DRAWIT_EDIT:
			return removeConfirm(state, confirmTypes.STUDENT_SUBMIT_DRAWIT_CONFIRMED)
		case t.DESMOS_INITIALIZE_ERROR:
			return [...defaultState, { confirmType: confirmTypes.DESMOS_INITIALIZE_ERROR }]
		case t.DESMOS_GET_RESULTS_ERROR:
			return [...defaultState, { confirmType: confirmTypes.DESMOS_GET_RESULTS_ERROR }]
		case t.MY_LIBRARY_FIRST_LESSON_FILE_PICKED_ERROR:
			return [...defaultState, {
				confirmType: confirmTypes.MY_LIBRARY_FIRST_LESSON_FILE_PICKED_ERROR,
				confirmProps: {message: action.message},
			}]
		case t.STUDENT_DELETE_AUDIO_OEQ_CONFIRM:
			return [...defaultState, {
				confirmType: t.STUDENT_DELETE_AUDIO_OEQ_CONFIRM,
			}]
		case t.STUDENT_DELETE_AUDIO_OEQ_CONFIRM_CANCEL:
		case t.STUDENT_DELETE_AUDIO_OEQ_CONFIRMED:
			return removeConfirm(state, confirmTypes.STUDENT_DELETE_AUDIO_OEQ_CONFIRM)
		case t.MY_LIBRARY_DUPLICATE_LESSON:
			return duplicateLessonConfirm(state, action)
		case t.MY_LIBRARY_DUPLICATE_LESSON_CONFIRM_DISMISS:
			return removeConfirm(state, confirmTypes.MY_LIBRARY_DUPLICATE_CONFIRM)
		case t.GOOGLE_SLIDES_SAVE_PRESENTATION_PROGRESSIVE_FAILED:
			return googleSlidesLessonSavedFailed(state, action)
		case t.GOOGLE_SLIDES_SAVE_PRESENTATION_FAILED_CONFIRMED:
			return removeConfirm(state, confirmTypes.GOOGLE_SLIDES_SAVE_PRESENTATION_FAILED_CONFIRM)
		case t.GOOGLE_SLIDES_AUTHORIZE_USER_FAILED:
			return googleSlidesAuthorizeUserFailed(state, action)
		case t.COOKIES_DISABLED_CLOSE_CONFIRM:
			return removeConfirm(state, confirmTypes.COOKIES_DISABLED_ERROR)
		case t.GOOGLE_SLIDES_AUTHORIZE_USER_SUCCESS:
		case t.GOOGLE_SLIDES_AUTHORIZE_USER_CANCEL:
			return removeConfirm(state, confirmTypes.GOOGLE_SLIDES_POP_UP_BLOCKED_CONFIRM)
		case t.MY_LIBRARY_CREATE_GOOGLE_DRIVE_LESSON_SUCCESS:
			return googleSlidesCreateLessonSuccess(state, action)
		case t.GOOGLE_SLIDES_LMS_OPEN_GOOGLE_CONFIRMED:
			return googleSlidesLMSOpenGoogleConfirmed(state, action)
		case t.GOOGLE_SLIDES_LMS_REFRESH_CONFIRMED:
			return removeConfirm(state, confirmTypes.GOOGLE_SLIDES_LMS_REFRESH_CONFIRM)
		case t.STUDENT_SUBMIT_FAILED:
			return confirmSubmitFailed(state, action)
		case t.STUDENT_SUBMIT_FAILED_GOT_IT:
			return removeConfirm(state, confirmTypes.STUDENT_SUBMIT_FAILED_CONFIRM)
		case t.STUDENT_REQUEST_MIC_PERMISSION:
			return studentRequestMicPermission(state, action)
		case t.STUDENT_REQUEST_MIC_PERMISSION_CANCEL:
			return removeConfirm(state, confirmTypes.STUDENT_REQUEST_MIC_PERMISSION)
		case t.QUICK_LAUNCH_LAUNCH_LESSON_FAILED:
			return quickLaunchLessonFailed()
		case t.QUICK_LAUNCH_CANCEL_LAUNCH:
		case t.QUICK_LAUNCH_RETRY_LAUNCH:
			return removeConfirm(state, confirmTypes.QUICK_LAUNCH_LAUNCH_LESSON_FAILED)
		case t.STUDENT_LEAD_SUBMIT_SUCCESS:
		case t.STUDENT_LEAD_SUBMIT_FAILED:
			return studentLeadShowMessage(action)
		case t.STUDENT_DRAW_IT_REVIEW_CONFIRMED:
			return removeConfirm(state, confirmTypes.STUDENT_SUBMIT_DRAWIT_REQUIRED)
		case t.VIDEO_CANCEL:
			return [...defaultState, {
				confirmType: confirmTypes.VIDEO_CANCEL_CONFIRM,
			}]
		case t.VIDEO_CANCEL_CONFIRMED:
		case t.VIDEO_CANCEL_REJECTED:
			return removeConfirm(state, confirmTypes.VIDEO_CANCEL_CONFIRM)
		case t.PAYWALLS_NOT_ENOUGH_SPACE_CONFIRM_CLOSE_SELECTED:
		case t.PAYWALLS_NOT_ENOUGH_SPACE_CONFIRM_UPGRADE_SELECTED:
			return removeConfirm(state, confirmTypes.PAYWALLS_NOT_ENOUGH_SPACE_CONFIRM)
		case t.PAYWALLS_PRESENTATION_SIZE_EXCEEDED_CONFIRM_ACCEPT_SELECTED:
		case t.PAYWALLS_PRESENTATION_SIZE_EXCEEDED_CONFIRM_UPGRADE_SELECTED:
		case t.PAYWALLS_PRESENTATION_SIZE_EXCEEDED_CONFIRM_CLOSE_SELECTED:
			return removeConfirm(state, confirmTypes.PAYWALL_PRESENTATION_SIZE_CONFIRM)
		case t.LOGIN_STUDENT_SUBMIT_LOGIN_GOOGLE_TOKEN_FAILED:
		case t.LOGIN_STUDENT_SUBMIT_LOGIN_OFFICE_365_TOKEN_FAILED:
			return [...defaultState, {
				confirmType: confirmTypes.STUDENT_NO_ACCOUNT_CONFIRM,
			}]
		case t.OEQ_AUDIO_RECORDER_DELETE_CONFIRM:
			if (action.hasAudioRecorded) {
				return [...defaultState, {
					confirmType: confirmTypes.OEQ_AUDIO_RECORDER_DELETE_CONFIRM,
				}]
			} else {
				return state
			}
		case t.OEQ_AUDIO_RECORDER_DELETE_CANCELLED:
		case t.OEQ_AUDIO_RECORDER_DELETE_CONFIRMED:
			return removeConfirm(state, confirmTypes.OEQ_AUDIO_RECORDER_DELETE_CONFIRM)
		case t.ONBOARDING_GUIDE_DISMISS_CONFIRM:
			return [...defaultState, {
				confirmType: confirmTypes.ONBOARDING_GUIDE_DISMISS_CONFIRM,
			}]
		case t.ONBOARDING_GUIDE_DISMISS_CANCELLED:
		case t.ONBOARDING_GUIDE_DISMISS_CONFIRMED:
			return removeConfirm(state, confirmTypes.ONBOARDING_GUIDE_DISMISS_CONFIRM)
		case t.DRAW_IT_AUDIO_PLAYER_DELETE_CONFIRM:
			return [...defaultState, {
				confirmType: confirmTypes.DRAW_IT_AUDIO_PLAYER_DELETE_CONFIRM,
			}]
		case t.DRAW_IT_AUDIO_PLAYER_DELETE_CANCELLED:
		case t.DRAW_IT_AUDIO_PLAYER_DELETE_CONFIRMED:
			return removeConfirm(state, confirmTypes.DRAW_IT_AUDIO_PLAYER_DELETE_CONFIRM)
		case t.DRAW_IT_AUDIO_RECORDER_DELETE_CONFIRM:
			return drawItDeleteAudioRecorderConfirm(state, action)
		case t.DRAW_IT_AUDIO_RECORDER_DELETE_CANCELLED:
		case t.DRAW_IT_AUDIO_RECORDER_DELETE_CONFIRMED:
			return removeConfirm(state, confirmTypes.DRAW_IT_AUDIO_RECORDER_DELETE_CONFIRM)
		default:
			return state
	}
}

export default confirmReducer
